/**
 * Which feature pages get the rich treatment, and how much of it.
 *
 * A key's ABSENCE is meaningful: the 21 feature pages that shipped before this
 * project have no entry, so FeaturePage renders them exactly as it always did.
 * Every new block is guarded on this lookup for that reason.
 *
 * `deepDive` is the number of detail rows, which is also the number of
 * d{n}t / d{n}b translation keys the page's copy must supply.
 * `spec` names the rows of the "what's included" table, each needing
 * spec.<row>.t and spec.<row>.d.
 */
export const RICH_FEATURES = {
  'dental-charting': { deepDive: 4, spec: ['fdi', 'surfaces', 'primary', 'history'] },
  'treatment-areas': { deepDive: 4, spec: ['areas', 'codes', 'pricing', 'history'] },
  'injectables':     { deepDive: 4, spec: ['regions', 'products', 'photos', 'consent'] },
  'records':         { deepDive: 4, spec: ['fields', 'files', 'standalone', 'sharing'] },
  'treatment-plans': { deepDive: 3, spec: ['items', 'money', 'staged'] },
  'agreements':      { deepDive: 4, spec: ['templates', 'scope', 'signing', 'pdf'] },
  'courses':         { deepDive: 4, spec: ['runs', 'seats', 'materials', 'certificates'] },
  'shop':            { deepDive: 4, spec: ['variants', 'inventory', 'barcode', 'collections'] },
  'pos':             { deepDive: 3, spec: ['basket', 'payments', 'receipts'] },
  'auto-ads':        { deepDive: 3, spec: ['connect', 'optimise', 'report'] },
  'hospitality':     { deepDive: 3, spec: ['nightly', 'stays', 'money'] },
  'rooms':           { deepDive: 3, spec: ['resources', 'couples', 'occupancy'] },
  'group-booking':   { deepDive: 4, spec: ['guests', 'phased', 'paying', 'waitlist'] },
  'messages':        { deepDive: 3, spec: ['whatsapp', 'broadcast', 'quota'] },
};
